import { render, staticRenderFns } from "./AddDirectInStockOne.vue?vue&type=template&id=f5071802&scoped=true"
import script from "./AddDirectInStockOne.vue?vue&type=script&lang=js"
export * from "./AddDirectInStockOne.vue?vue&type=script&lang=js"
import style0 from "./AddDirectInStockOne.vue?vue&type=style&index=0&id=f5071802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5071802",
  null
  
)

export default component.exports